<template>
    <Container>
        <template v-slot:header>
            <TopBanner></TopBanner>
        </template>
        <div class="scroll-container" v-loading="isLoading" v-if="!isLoading">
            <!-- 查询条件 -->
            <SearchLine :entitys="entityList" @search="onSearch"></SearchLine>
            <div class="report-content">
                <div class="report-content-line">
                    <!-- 数量统计 -->
                    <TotalNumber ref="rpt1"></TotalNumber>
                </div>
                <div class="report-content-line">
                    <!-- 高峰时段 -->
                    <PeakPeriod ref="rpt2"></PeakPeriod>
                    <!-- 集团排名 -->
                    <SingleRankData ref="rpt3" class="signle-rank-card multi-card"></SingleRankData>
                </div>
                <div class="report-content-line">
                    <!-- 实时数据 -->
                    <FlowNow ref="rpt4"></FlowNow>
                    <!-- 累计数据 -->
                    <FlowTotal ref="rpt5" class="multi-card"></FlowTotal>
                </div>
                <div class="report-content-line">
                    <!-- 近期趋势 -->
                    <FlowWeather ref="rpt6"></FlowWeather>
                </div>
                <div class="report-content-line">
                    <!-- 排行 -->
                    <FlowRank ref="rpt7"></FlowRank>
                </div>
                <div class="report-content-line">
                    <!-- 顾客分布特征 -->
                    <FlowSex></FlowSex>
                    <!-- 顾客年龄分布 -->
                    <FlowAge class="multi-card"></FlowAge>
                </div>
            </div>
        </div>
    </Container>
</template>
<script>
import FlowAge from "../components/FlowAge.vue";
import FlowNow from "../components/FlowNow.vue";
import FlowRank from "../components/FlowRank.vue";
import FlowSex from "../components/FlowSex.vue";
import FlowTotal from "../components/FlowTotal.vue";
import FlowWeather from "../components/FlowWeather.vue";
import SingleRankData from "../components/SingleRankData.vue";
import PeakPeriod from "../components/PeakPeriod.vue";
import SearchLine from "../components/SearchLine.vue";
import TopBanner from "../components/TopBanner.vue";
import TotalNumber from "../components/TotalNumber.vue";
export default {
    components: { TopBanner, TotalNumber, SearchLine, PeakPeriod, SingleRankData, FlowAge, FlowNow, FlowRank, FlowSex, FlowTotal, FlowWeather },
    name: "base",
    data() {
        return {
            isLoading: true,
            entityList: [],
        };
    },
    created() {
        this.getEntitys();
    },
    mounted() {
        window.onresize = this.onResize;
    },
    methods: {
        getEntitys() {
            this.$ajax
                .post("/Entity/GetAllEntities")
                .then((result) => {
                    this.entityList = result.Data;
                    this.isLoading = false;
                })
                .catch((err) => {
                    this.isLoading = false;
                });
        },
        onResize() {
            for (let key in this.$refs) {
                if (this.$refs[key] && this.$refs[key].resize) {
                    this.$refs[key].resize();
                }
            }
        },
        onSearch(data) {
            this.$refs.rpt1.setData(data);
            this.$refs.rpt2.setData(data);
            this.$refs.rpt3.setData(data);
            this.$refs.rpt4.setData(data);
            this.$refs.rpt5.setData(data);
            this.$refs.rpt6.setData(data);
            this.$refs.rpt7.setData(data);
        },
    },
};
</script>

<style scoped>
.signle-rank-card {
    width: 400px;
    flex: none;
}
.multi-card {
    margin-left: 40px;
}
</style>
